import svgPaths from '../../../assets/imports/PgrmLandingPageDeslogada/svg-huqtkssm9g';
import { useInView } from '../../../hooks/useInView';
import styles from './NovidadesRow.module.scss';

interface Feature {
  readonly path: string;
  readonly lines: string[];
  readonly clip?: boolean;
}

const FEATURES: Feature[] = [
  { path: svgPaths.p3bd25c00, lines: ['Login gov.br', 'Prata ou Ouro'] },
  { path: svgPaths.p10b60800, lines: ['Registro detalhado', 'das operações'] },
  {
    path: svgPaths.p173e8800,
    lines: ['Mais opções de pagamento', '(Pix e Cartão de Crédito)'],
  },
  { path: svgPaths.p2d7a4e00, lines: ['Mais controle e', 'rastreabilidade'] },
  {
    path: svgPaths.p352c8280,
    lines: ['Mais transparência para ', 'estados e municípios'],
    clip: true,
  },
];

function FeatureCol({
  feature,
  delay,
}: Readonly<{ feature: Feature; delay: number }>) {
  const [ref, inView] = useInView<HTMLDivElement>();
  return (
    <div
      ref={ref}
      className={`${styles.col} ${inView ? 'inView' : ''}`}
      style={{ transitionDelay: `${delay}s` }}
    >
      <div className={styles.iconWrap}>
        <svg
          className={styles.icon}
          fill='none'
          height='64'
          viewBox='0 0 64 64'
          width='64'
        >
          {feature.clip ? (
            <>
              <g clipPath='url(#clip-feature)'>
                <path
                  d={feature.path}
                  stroke='#168821'
                  strokeLinecap='round'
                  strokeWidth='2'
                />
              </g>
              <defs>
                <clipPath id='clip-feature'>
                  <rect fill='white' height='64' width='64' />
                </clipPath>
              </defs>
            </>
          ) : (
            <path
              d={feature.path}
              stroke='#168821'
              strokeLinecap='round'
              strokeWidth='2'
            />
          )}
        </svg>
      </div>
      <div className={styles.labels}>
        {feature.lines.map((line) => (
          <p key={line}>{line}</p>
        ))}
      </div>
    </div>
  );
}

export function NovidadesRow() {
  return (
    <div className={styles.section} data-name='novidades-row'>
      <p className={styles.title}>Principais novidades da PGRM:</p>
      <div className={styles.row}>
        {FEATURES.map((f, i) => (
          <div key={f.lines[0]} className={styles.cell}>
            <FeatureCol feature={f} delay={i * 0.1} />
            {i < FEATURES.length - 1 && <div className={styles.divider} />}
          </div>
        ))}
      </div>
    </div>
  );
}
